import React from 'react'
import { MotionButton, MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function OurPromiseSection() {
  return (
    <MotionSection className="w-[96%] mx-auto py-12 lg:py-16">
      <div className="grid gap-8 lg:grid-cols-2 lg:items-center">
        <MotionImage className="w-full max-w-2xl lg:max-w-[820px] overflow-hidden rounded-2xl lg:rounded-l-2xl" delay={0.02}>
          <img
            src="/images/sectionimages/our%20promise.png"
            alt="Our Promise"
            className="w-full h-80 sm:h-[360px] lg:h-[460px] object-contain"
          />
        </MotionImage>

        <MotionDiv className="max-w-xl" delay={0.08}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-gray-900">Our Promise</h2>
          <p className="mt-4 text-sm sm:text-base leading-relaxed text-gray-700">
            To every facility manager, marketing director, and business owner in Zambia: when you choose Logo Branded Door Mats Zambia,
            you are choosing a partner dedicated to maximizing the return on your first impression. We deliver durability, speed, and
            local service that you can trust.
          </p>

          <div className="mt-6">
            <button className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors">
              <MotionButton>Shop Now</MotionButton>
            </button>
          </div>
        </MotionDiv>
      </div>
    </MotionSection>
  )
}
